function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_37"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_1"
}, /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_2",
  fill: "#FFD15C",
  points: "512.9330444335938,55.40761083555935 463.74231329930626,47.375741078151805 455.7104119716969,0.192535400390625 448.68370587025856,48.37996552061668 402.50379331400836,55.40761083555935 448.68370587025856,62.434316936997675 455.7104119716969,110.62173916467327 463.74231329930626,63.43853348691209 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_3",
  fill: "#FFD15C",
  points: "115.38673015662789,0.192535400390625 113.37922837775295,19.267038245389813 93.30146398144461,22.278748681628713 112.37502761293945,25.29046701041807 115.38673015662789,44.364030641912905 119.40266503533167,25.29046701041807 138.4771599877804,22.278748681628713 118.39844848541725,19.267038245389813 "
})), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_4",
  fill: "#CDD6E0",
  points: "88.28129676772551,61.43103960058761 83.26209244516212,27.297960896742552 78.24287233749783,61.43103960058761 45.114018076117645,66.45025181570145 78.24287233749783,72.4736805807297 83.26209244516212,106.60675139202431 88.28129676772551,72.4736805807297 123.41859991403544,66.45025181570145 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_5",
  fill: "#84DBFF",
  points: "348.2929265362036,202.9815958473755 287.0544381211075,86.52802410456025 261.9574536171349,86.52802410456025 193.69131199454569,202.9815958473755 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_6",
  fill: "#54C0EB",
  points: "426.5975083741214,86.52802410456025 287.0544381211075,86.52802410456025 348.2929265362036,202.9815958473755 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_7",
  fill: "#84DBFF",
  points: "510.92549529941607,202.9815958473755 427.60175649423763,86.52802410456025 426.5975083741214,86.52802410456025 348.2929265362036,202.9815958473755 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_8",
  fill: "#F2F2F2",
  points: "271.99586226226165,482.06680503244934 348.2929265362036,202.9815958473755 193.69131199454569,202.9815958473755 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_9",
  fill: "#54C0EB",
  points: "261.9574536171349,86.52802410456025 117.39516325645673,86.52802410456025 193.69131199454569,202.9815958473755 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_10",
  fill: "#84DBFF",
  points: "117.39516325645673,86.52802410456025 116.39094670654231,86.52802410456025 33.067176331162045,202.9815958473755 193.69131199454569,202.9815958473755 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_11",
  fill: "#54C0EB",
  points: "510.92549529941607,202.9815958473755 271.99586226226165,482.06680503244934 33.067176331162045,202.9815958473755 193.69131199454569,202.9815958473755 271.99586226226165,482.06680503244934 348.2929265362036,202.9815958473755 "
}), /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_12"
}, /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_13",
  fill: "#FFFFFF",
  points: "348.2929265362036,171.86024336487026 344.27700744260073,197.9614444187573 317.17158983879926,201.97737929746108 344.27700744260073,205.99332996126577 348.2929265362036,234.10203279402776 352.3088772000083,205.99332996126577 379.41429480380975,201.97737929746108 352.3088772000083,197.9614444187573 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_14",
  fill: "#FFFFFF",
  points: "151.52728696169652,113.63345749346263 147.51231497414847,139.7356056534045 120.40688158524608,143.75060921115437 146.50806685403222,147.76652830475723 151.52728696169652,175.87617824357403 155.5432376255012,148.77076063977256 182.64865522930268,143.75060921115437 155.5432376255012,139.7356056534045 "
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_36"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  id: "svg_33",
  fill: "#4caf50",
  d: "m294.59094,320.748l-264.32473,0c-11.51907,0 -20.86781,9.34874 -20.86781,20.86781l0,13.91102c0,11.51907 9.34874,20.86781 20.86781,20.86781l264.32473,0c11.51907,0 20.86781,-9.34874 20.86781,-20.86781l0,-13.91102c0,-11.51907 -9.34874,-20.86781 -20.86781,-20.86781zm0,0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  id: "svg_34",
  fill: "#4caf50",
  d: "m134.60525,216.40895l0,264.32473c0,11.51907 9.34874,20.86781 20.86781,20.86781l13.91102,0c11.51907,0 20.86781,-9.34874 20.86781,-20.86781l0,-264.32473c0,-11.51907 -9.34874,-20.86781 -20.86781,-20.86781l-13.91102,0c-11.51907,0 -20.86781,9.34874 -20.86781,20.86781zm0,0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  id: "svg_35",
  fill: "#000000",
  d: "m172.86375,501.60149l-20.86781,0c-13.42703,0 -24.34748,-10.92044 -24.34748,-24.34493l0,-93.90514l-93.90514,0c-13.42448,0 -24.34493,-10.92044 -24.34493,-24.34493l0,-20.86781c0,-13.42703 10.92044,-24.34748 24.34493,-24.34748l93.90514,0l0,-93.90514c0,-13.42448 10.92045,-24.34493 24.34748,-24.34493l20.86781,0c13.42448,0 24.34493,10.92044 24.34493,24.34493l0,93.90514l93.90514,0c13.42448,0 24.34493,10.92045 24.34493,24.34748l0,20.86781c0,13.42448 -10.92044,24.34493 -24.34493,24.34493l-93.90514,0l0,93.90514c0,13.42448 -10.92044,24.34493 -24.34493,24.34493zm-139.12043,-166.94247c-1.91814,0 -3.47712,1.55898 -3.47712,3.47967l0,20.86781c0,1.91814 1.55898,3.47712 3.47712,3.47712l104.33905,0c5.75953,0 10.4339,4.67437 10.4339,10.4339l0,104.33905c0,1.92069 1.55898,3.47712 3.47967,3.47712l20.86781,0c1.91815,0 3.47712,-1.55643 3.47712,-3.47712l0,-104.33905c0,-5.75953 4.67437,-10.4339 10.4339,-10.4339l104.33905,0c1.92069,0 3.47712,-1.55897 3.47712,-3.47712l0,-20.86781c0,-1.92069 -1.55643,-3.47967 -3.47712,-3.47967l-104.33905,0c-5.75953,0 -10.4339,-4.67437 -10.4339,-10.4339l0,-104.33905c0,-1.91814 -1.55897,-3.47712 -3.47712,-3.47712l-20.86781,0c-1.92069,0 -3.47967,1.55898 -3.47967,3.47712l0,104.33905c0,5.75953 -4.67437,10.4339 -10.4339,10.4339l-104.33905,0zm0,0"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/addDiamond.181f93c4.svg";
export { SvgComponent as ReactComponent };